import { Link } from "react-router-dom";
import { useI18n } from "@/i18n/LanguageContext";
import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";
import { privacyPolicy, PRIVACY_UPDATED } from "@/content/privacyPolicy";

const CONTACT_EMAIL = "info@vaya-transfer.com";

export default function Privacy() {
  const { t, lang } = useI18n();
  const sections = privacyPolicy[lang] || privacyPolicy.en;

  return (
    <div className="min-h-screen bg-background">
      <Header />
      <div className="mx-auto max-w-3xl px-5 py-14 lg:py-20">
        <p className="label-eyebrow">{t("legal.eyebrow")}</p>
        <h1 className="mt-3 font-display text-3xl tracking-tight sm:text-4xl" data-testid="privacy-title">
          {t("legal.privacy")}
        </h1>
        <p className="mt-3 text-sm text-slate-500">
          {t("legal.updated")}:{" "}
          {new Date(`${PRIVACY_UPDATED}T12:00:00`).toLocaleDateString(lang, {
            day: "numeric",
            month: "long",
            year: "numeric",
          })}
        </p>
        <p className="mt-6 rounded-lg border border-slate-200 bg-white p-4 text-xs leading-relaxed text-slate-500">
          {t("legal.langNote")}
        </p>

        {sections.map((s, i) => (
          <section className="mt-10" key={s.title} data-testid={`privacy-section-${i + 1}`}>
            <h2 className="font-display text-xl tracking-tight sm:text-2xl">
              {i + 1}. {s.title}
            </h2>
            <div className="mt-3 space-y-3 text-sm leading-relaxed text-slate-600">
              {s.body.map((p, j) => (
                <p key={`${s.title}-${j}`}>{p}</p>
              ))}
            </div>
          </section>
        ))}

        <p className="mt-10 text-sm text-slate-600">
          <a className="font-semibold text-sea underline" href={`mailto:${CONTACT_EMAIL}`} data-testid="privacy-contact-email">
            {CONTACT_EMAIL}
          </a>
        </p>

        <div className="mt-14 border-t border-slate-200 pt-8">
          <Link to="/" data-testid="privacy-back-home" className="text-sm font-semibold text-sea underline">
            {t("nav.book")}
          </Link>
        </div>
      </div>
      <Footer />
    </div>
  );
}
